/* Persée — méga-menu (ordinateur) et tiroir mobile */
(function () {
  var DESKTOP = window.matchMedia('(min-width: 1100px)');

  function handleize(s) {
    return (s || '').toLowerCase().normalize('NFD').replace(/[̀-ͯ]/g, '').replace(/['’]/g, '')
      .replace(/[^a-z0-9]+/g, '-').replace(/^-+|-+$/g, '');
  }

  // Rattache les panneaux de la section « Menu Persée » aux catégories du menu de l'en-tête
  // par position (identique dans toutes les langues), sinon par intitulé.
  function mountPanels() {
    var src = document.querySelector('[data-pm-source]');
    var nav = document.querySelector('header .header__inline-menu');
    if (!src || !nav) return;
    var lis = Array.prototype.slice.call(nav.querySelectorAll(':scope > ul > li'));
    src.querySelectorAll('[data-pm-panel]').forEach(function (panel) {
      var idx = parseInt(panel.getAttribute('data-pm-index'), 10);
      var li = idx ? lis[idx - 1] : null;
      if (!li) {
        var cat = panel.getAttribute('data-pm-cat');
        li = lis.find(function (l) {
          var a = l.querySelector(':scope > a');
          return a && handleize(a.getAttribute('aria-label') || a.textContent) === cat;
        });
      }
      if (!li) return;
      li.querySelectorAll(':scope > [data-pm-panel]').forEach(function (old) { old.remove(); });
      li.appendChild(panel);
      li.classList.add('pm-li');
      li.setAttribute('data-pm-li', '');
      delete li.dataset.pmReady;
    });
  }

  // Place le bouton du menu mobile à l'emplacement du bouton d'origine
  function mountBurger() {
    var wrap = document.querySelector('[data-pm-burger-wrap]');
    var header = document.querySelector('header.header');
    if (!wrap || !header) return;
    var old = header.querySelector('header-drawer');
    if (old) old.parentNode.insertBefore(wrap, old);
    else header.insertBefore(wrap, header.firstChild);
    document.documentElement.classList.add('pm-ready');
  }

  function closeAllPanels(except) {
    document.querySelectorAll('[data-pm-li]').forEach(function (li) {
      if (li === except) return;
      var p = li.querySelector('[data-pm-panel]');
      if (p) p.hidden = true;
      li.classList.remove('pm-open');
      var a = li.querySelector(':scope > a');
      if (a) a.setAttribute('aria-expanded', 'false');
    });
  }

  function updateArrows(panel) {
    var track = panel.querySelector('[data-pm-track]');
    if (!track) return;
    var prev = panel.querySelector('[data-pm-prev]');
    var next = panel.querySelector('[data-pm-next]');
    var overflow = track.scrollWidth > track.clientWidth + 2;
    if (prev) prev.hidden = !overflow || track.scrollLeft <= 2;
    if (next) next.hidden = !overflow || track.scrollLeft + track.clientWidth >= track.scrollWidth - 2;
  }

  function initDesktop() {
    document.querySelectorAll('[data-pm-li]').forEach(function (li) {
      if (li.dataset.pmReady) return;
      li.dataset.pmReady = '1';
      var panel = li.querySelector('[data-pm-panel]');
      if (!panel) return;
      var link = li.querySelector(':scope > a');
      var timer;
      if (link) {
        link.setAttribute('aria-haspopup', 'true');
        link.setAttribute('aria-expanded', 'false');
      }
      function open() {
        if (!DESKTOP.matches) return;
        clearTimeout(timer);
        closeAllPanels(li);
        panel.hidden = false;
        li.classList.add('pm-open');
        if (link) link.setAttribute('aria-expanded', 'true');
        updateArrows(panel);
      }
      function close() {
        timer = setTimeout(function () {
          panel.hidden = true;
          li.classList.remove('pm-open');
          if (link) link.setAttribute('aria-expanded', 'false');
        }, 160);
      }
      li.addEventListener('mouseenter', open);
      li.addEventListener('mouseleave', close);
      li.addEventListener('focusin', open);
      li.addEventListener('focusout', function (e) {
        if (!li.contains(e.relatedTarget)) close();
      });
      li.addEventListener('keydown', function (e) {
        if (e.key === 'Escape') {
          panel.hidden = true;
          if (link) link.focus();
        }
      });
      var track = panel.querySelector('[data-pm-track]');
      if (track) {
        track.addEventListener('scroll', function () { updateArrows(panel); }, { passive: true });
        var prev = panel.querySelector('[data-pm-prev]');
        var next = panel.querySelector('[data-pm-next]');
        if (prev) prev.addEventListener('click', function () { track.scrollBy({ left: -track.clientWidth, behavior: 'smooth' }); });
        if (next) next.addEventListener('click', function () { track.scrollBy({ left: track.clientWidth, behavior: 'smooth' }); });
      }
    });
  }

  function initDrawer() {
    var drawers = document.querySelectorAll('[data-pm-drawer]');
    if (!drawers.length) return;
    var drawer = drawers[drawers.length - 1];
    drawers.forEach(function (d) { if (d !== drawer) d.remove(); });
    if (drawer.parentElement !== document.body) document.body.appendChild(drawer);
    if (drawer.dataset.pmReady) return;
    drawer.dataset.pmReady = '1';

    var root = drawer.querySelector('[data-pm-level="root"]');

    function showLevel(name) {
      drawer.querySelectorAll('.pm-level--2').forEach(function (l) {
        var on = l.getAttribute('data-pm-level') === name;
        if (on) {
          l.hidden = false;
          l.scrollTop = 0;
          requestAnimationFrame(function () { l.classList.add('is-active'); });
        } else {
          l.classList.remove('is-active');
          l.hidden = true;
        }
      });
    }
    function setExpanded(v) {
      document.querySelectorAll('[data-pm-burger]').forEach(function (b) { b.setAttribute('aria-expanded', v); });
    }
    function open() {
      if (!document.body.contains(drawer)) return;
      drawer.hidden = false;
      requestAnimationFrame(function () { drawer.classList.add('is-open'); });
      document.documentElement.classList.add('pm-lock');
      setExpanded('true');
      var first = drawer.querySelector('[data-pm-close]');
      if (first) first.focus();
    }
    function close() {
      drawer.classList.remove('is-open');
      document.documentElement.classList.remove('pm-lock');
      setExpanded('false');
      setTimeout(function () { drawer.hidden = true; showLevel(null); }, 350);
    }
    document.addEventListener('click', function (e) {
      if (e.target.closest('[data-pm-burger]')) { e.preventDefault(); open(); }
    });
    drawer.addEventListener('click', function (e) {
      var t;
      if ((t = e.target.closest('[data-pm-close]'))) { close(); return; }
      if ((t = e.target.closest('[data-pm-open]'))) { showLevel(t.getAttribute('data-pm-open')); return; }
      if ((t = e.target.closest('[data-pm-back]'))) { showLevel(null); if (root) root.scrollTop = 0; }
    });
    drawer.addEventListener('keydown', function (e) { if (e.key === 'Escape') close(); });
  }

  function init() {
    mountPanels();
    mountBurger();
    initDesktop();
    initDrawer();
  }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();

  document.addEventListener('shopify:section:load', function () {
    document.querySelectorAll('body > [data-pm-drawer]').forEach(function (d) { d.remove(); });
    document.querySelectorAll('header [data-pm-li] > [data-pm-panel]').forEach(function (p) { p.remove(); });
    document.querySelectorAll('header.header [data-pm-burger-wrap]').forEach(function (w) { w.remove(); });
    init();
  });

  // Éditeur de thème : ouvrir le panneau ou le tiroir quand un bloc du menu est sélectionné
  document.addEventListener('shopify:block:select', function (e) {
    var el = e.target;
    if (!el || !el.closest) return;
    var panel = el.closest('[data-pm-panel]');
    if (panel) {
      var li = panel.closest('[data-pm-li]');
      closeAllPanels(li);
      panel.hidden = false;
      updateArrows(panel);
    }
    var level = el.closest('.pm-level--2');
    if (level) {
      var drawer = level.closest('[data-pm-drawer]');
      if (drawer) {
        drawer.hidden = false;
        drawer.classList.add('is-open');
        level.hidden = false;
        level.classList.add('is-active');
      }
    }
  });
})();
